import { render } from "./PalaLink.vue?vue&type=template&id=1b833f78&ts=true"
import script from "./PalaLink.vue?vue&type=script&lang=ts"
export * from "./PalaLink.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__